var endpointMap = {
	de: {
		"roots.footer": "translation-de.json",
		"roots.header": "translation-de.json"
	},
	"de-DE": {
		"roots.footer": "translation-de.json",
		"roots.header": "translation-de.json"
	},
	en: {
		"roots.footer": "translation-en.json",
		"roots.header": "translation-en.json"
	},
	"en-US": {
		"roots.footer": "translation-en.json",
		"roots.header": "translation-en.json"
	},
	es: {
		"roots.footer": "translation-es.json",
		"roots.header": "translation-es.json"
	},
	"es-ES": {
		"roots.footer": "translation-es.json",
		"roots.header": "translation-es.json"
	},
	"es-MX": {
		"roots.footer": "translation-es.json",
		"roots.header": "translation-es.json"
	},
	"es-US": {
		"roots.footer": "translation-es.json",
		"roots.header": "translation-es.json"
	},
	fr: {
		"roots.footer": "translation-fr.json",
		"roots.header": "translation-fr.json"
	},
	"fr-BE": {
		"roots.footer": "translation-fr.json",
		"roots.header": "translation-fr.json"
	},
	"fr-CA": {
		"roots.footer": "translation-fr.json",
		"roots.header": "translation-fr.json"
	},
	"fr-FR": {
		"roots.footer": "translation-fr.json",
		"roots.header": "translation-fr.json"
	},
	it: {
		"roots.footer": "translation-it.json",
		"roots.header": "translation-it.json"
	},
	"it-IT": {
		"roots.footer": "translation-it.json",
		"roots.header": "translation-it.json"
	},
	ja: {
		"roots.footer": "translation-ja.json",
		"roots.header": "translation-ja.json"
	},
	"ja-JP": {
		"roots.footer": "translation-ja.json",
		"roots.header": "translation-ja.json"
	},
	pl: {
		"roots.footer": "translation-pl.json",
		"roots.header": "translation-pl.json"
	},
	"pl-PL": {
		"roots.footer": "translation-pl.json",
		"roots.header": "translation-pl.json"
	},
	pt: {
		"roots.footer": "translation-pt.json",
		"roots.header": "translation-pt.json"
	},
	"pt-BR": {
		"roots.footer": "translation-pt.json",
		"roots.header": "translation-pt.json"
	},
	"pt-PT": {
		"roots.footer": "translation-pt.json",
		"roots.header": "translation-pt.json"
	},
	und: {
		"roots.footer": "translation.json",
		"roots.header": "translation.json"
	},
	zh: {
		"roots.footer": "translation-zh.json",
		"roots.header": "translation-zh.json"
	},
	"zh-CN": {
		"roots.footer": "translation-zh.json",
		"roots.header": "translation-zh.json"
	},
	"zh-TW": {
		"roots.footer": "translation-zh.json",
		"roots.header": "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
